module.exports = __webpack_public_path__ + "static/media/arco-logo-charcoal.766e7559.svg";